import moment from 'moment';
import getFilterWithCol from '../../helpers/getFilterWithCol';
import clickAnchor from '../../helpers/clickAnchor';

import Types from '../../modules/types';

import {
  filterSortCreatedUpdatedName as filterSort,
} from '../../components/common';

import tests from '../../helpers/tests';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { storeId: { REGEX: value, OPTIONS: 'i' } },
        { name: { REGEX: value, OPTIONS: 'i' } },
        { email: { REGEX: value, OPTIONS: 'i' } },
        { slug: { REGEX: value, OPTIONS: 'i' } },
        { domains: { REGEX: value, OPTIONS: 'i' } },
      ],
    }
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search by ID, name, email, link or domain',
  }],
}];

export const filterType = ['FilterField', {
  id: 'type',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    ...Types.STORE_TYPE.reduce(
      (agr, id) => {
        agr[id.toLowerCase()] = { type: { EQ: id } };
        return agr;
      },
      {
        internal: { internal: true },
      },
    ),
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : null
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldSelect', {
    name: 'type',
    placeholder: 'Type',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [
      { label: 'Any Type', value: 'any' },
      ...Types.STORE_TYPE_LIST.map(({ id, label }) => ({
        label,
        value: id.toLowerCase(),
      })),
      { label: 'Internal', value: 'internal' },
    ],
  }],
}];

export const filterAccountManager = ['FilterField', {
  id: 'accountManager',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => {
    if (!value || !value.length) {
      return;
    }
    const values = Array.isArray(value) ? value : [value];
    builder.add('where', { accountManager: { IN: values } });
  },
  getValueForField: value => (
    Array.isArray(value)
    ? value
    : value
    ? [value]
    : []
  ),
  field: ['FieldConnectionSelect', {
    name: 'accountManager',
    url: '/users/admins',
    placeholder: 'Account Manager',
    mode: 'multiple',
    allowClear: true,
    getChoiceLabel: choice => (
      choice?.email
      ? `${choice.name} (${choice.email})`
      : choice?.name || ''
    ),
  }],
}];

export const filterActive = ['FilterField', {
  id: 'active',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    active: { active: { EQ: true } },
    inactive: { active: { EQ: false } },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : value === 'any'
    ? null
    : builder.add('where', { ...filter.VALUES_MAP.active })
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : 'active'
  ),
  field: ['FieldRadio', {
    name: 'active',
    block: true,
    placeholder: 'Active Status',
    prepareValueForInput: value => (value ? value : 'active'),
    choices: [{
      label: 'Active',
      value: 'active',
    }, {
      label: 'Inactive',
      value: 'inactive',
    }, {
      label: 'All',
      value: 'any',
    }],
  }],
}];
export const filterKeyAccountService = ['FilterField', {
  id: 'filterKeyAccountService',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    key: { AND: [
      {
        keyAccount: { EQ: true },
      },
    ] },
    normal: { OR: [
      {
        keyAccount: { EQ: false },
      },
      { keyAccount: { EQ: null } },
    ] },
  },
  buildQuery: (value, builder, filter) => {
    const val = filter.VALUES_MAP[value];
    return filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : value === 'any'
    ? null
    : builder.add('where', { ...filter.VALUES_MAP.any })
  },
  getValueForField: value => (
    value && value.length
    ? value
    : 'any'
  ),
  field: ['FieldRadio', {
    name: 'active',
    block: true,
    placeholder: 'Active Status',
    initialValue: 'any',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [
      {
        label: 'All',
        value: 'any',
      }, {
        label: 'Key Accounts',
        value: 'key',
      }, {
        label: 'Normal Accounts',
        value: 'normal',
      },
    ],
  }],
}];
export const filterAcountManagementService = ['FilterField', {
  id: 'accountMangementService',
  label: 'Account manangement Subscriptions',
  section: 'top',
  VALUES_MAP: {
    any: null,
    active: { AND: [
      {
        'accountManagementService.active': { EQ: true },
      },
      { 'accountManagementService.endDate': {
        GTE: moment().toJSON(),
      } },
    ] },
    inactive: { OR: [
      { 'accountManagementService.active': { EQ: false } },
      { accountManagementService: { EQ: null } },
    ] },
    expiringSoon: { AND: [
      { 'accountManagementService.active': { EQ: true } },
      { 'accountManagementService.endDate': {
        GTE: moment().toJSON(),
        LTE: moment().add(30, 'days').toJSON(),
      } },
    ] },
    expired: { AND: [
      { 'accountManagementService.active': { EQ: true } },
      { 'accountManagementService.endDate': { LTE: moment().toJSON() } },
    ] },
  },
  buildQuery: (value, builder, filter) => {
    const val = filter.VALUES_MAP[value];
    console.log({ val });
    return filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : value === 'any'
    ? null
    : builder.add('where', { ...filter.VALUES_MAP.any })
  },
  getValueForField: value => (
    value && value.length
    ? value
    : 'any'
  ),
  field: ['FieldRadio', {
    name: 'active',
    block: true,
    placeholder: 'Active Status',
    initialValue: 'any',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [
      {
        label: 'All',
        value: 'any',
      }, {
        label: 'Active',
        value: 'active',
      }, {
        label: 'Inactive',
        value: 'inactive',
      }, {
        label: 'Expiring Soon (Next 30 Days)',
        value: 'expiringSoon',
      }, {
        label: 'Expired',
        value: 'expired',
      },
    ],
  }],
}];
export const filterWarehouseServiceService = ['FilterField', {
  id: 'warehouseService',
  label: 'Warehouse service Subscriptions',
  section: 'top',
  VALUES_MAP: {
    any: null,
    active: { AND: [
      {
        'warehouseService.active': { EQ: true },
      },
      { 'warehouseService.endDate': {
        GTE: moment().toJSON(),
      } },
    ] },
    inactive: { OR: [
      { 'warehouseService.active': { EQ: false } },
      { warehouseService: { EQ: null } },
    ] },
    expiringSoon: { AND: [
      { 'warehouseService.active': { EQ: true } },
      { 'warehouseService.endDate': {
        GTE: moment().toJSON(),
        LTE: moment().add(30, 'days').toJSON(),
      } },
    ] },
    expired: { AND: [
      { 'warehouseService.active': { EQ: true } },
      { 'warehouseService.endDate': { LTE: moment().toJSON() } },
    ] },
  },
  buildQuery: (value, builder, filter) => {
    const val = filter.VALUES_MAP[value];
    return filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : value === 'any'
    ? null
    : builder.add('where', { ...filter.VALUES_MAP.any })
  },
  getValueForField: value => (
    value && value.length
    ? value
    : 'any'
  ),
  field: ['FieldRadio', {
    name: 'active',
    block: true,
    placeholder: 'Active Status',
    initialValue: 'any',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [
      {
        label: 'All',
        value: 'any',
      }, {
      label: 'Active',
      value: 'active',
    }, {
      label: 'Expiring Soon (Next 30 Days)',
      value: 'expiringSoon',
    }, {
      label: 'Inactive',
      value: 'inactive',
    }, {
      label: 'Expired',
      value: 'expired',
    }],
  }],
}];

export const [
  filterGenerateReportSubscriptions,
] = [
  [
    'generate-report-stores',
    'Stores Report',
    'report/stores',
  ],
].map(([id, title, path]) => (['FilterField', {
  id,
  name: id,
  label: null,
  section: 'top',
  buildQuery: () => {},
  skip: [tests.viewerIsAdminAndDoesNotHavePermission('reportsExport')],
  // eslint-disable-next-line max-len
  propsFromPage: ({ client, queryBuilder, restBaseServer, searchParams }) => ({
    client,
    queryBuilder,
    restBaseServer,
    searchParams,
  }),
  field: ['Action', {
    name: id,
    title,
    icon: 'download',
    type: 'default',
    style: { width: '100%' },
    onClick: (props) => clickAnchor({
      url: `${props.restBaseServer}/stores/${path}`,
      query: {
        access_token: props.client.getAccessToken(),
        query: props.queryBuilder.compile(),
        systemCountry: props.searchParams.sc,
      },
    }),
  }],
}]));

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPeriodRange = ['FilterField', {
  id: 'periodRange',
  label: null,
  section: 'top',
  placeholder: ['From Date', 'To Date'],
  propsFromPage: props => ({
    searchParams: props.searchParams,
    history: props.history,
  }),
  ranges: {
    ...[
      ['Today', 0],
      ['Last 7 Days', 7],
      ['Last 30 Days', 30],
      ['Last 60 Days', 60],
      ['Last 90 Days', 90],
      ['Last 180 Days', 180],
    ].reduce(
      (agr, [label, daysOffset = null]) => {
        agr[label] = () => {
          const now = moment();
          return [
            now.clone().subtract(Math.max(0, daysOffset - 1), 'days'),
            now,
          ];
        };
        return agr;
      },
      {},
    ),
    ...[
      ['Week', 'week'],
      ['Month', 'month'],
      ['Year', 'year'],
    ].reduce(
      (agr, [label, value]) => {
        agr[`This ${label}`] = [
          moment().startOf(value),
          moment().endOf(value),
        ];
        agr[`Past ${label}`] = [
          moment().subtract(1, value).startOf(value),
          moment().subtract(1, value).endOf(value),
        ];
        agr[`2 ${label}s Ago`] = [
          moment().subtract(2, value).startOf(value),
          moment().subtract(2, value).endOf(value),
        ];
        return agr;
      },
      {},
    ),
  },
  buildQuery: (value, builder, filter, _2, { pageProps }) => {
    const now = moment();
    const startOf2020 = moment('2020-01-01T00:00:00');
    const isSideB = filter.id.indexOf('b.') === 0
    const whereKey = isSideB ? 'whereB' : 'where';
    const dateKeyRaw = (
      isSideB
        ? pageProps.searchParams.b?.date
        : pageProps.searchParams.date
    );
    const dateKey = (
     'createdAt'
    );
    if (
      value
      && value.length
    ) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
            // .hour(now.hour())
            // .minute(now.minute())
            // .second(now.second())
            // .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        builder.add(
          whereKey,
          {
            [dateKey]: {
              GTE: values[0].startOf('day').toJSON(),
              LTE: values[1].endOf('day').toJSON(),
            },
          },
        );
        return;
      }
    }
    builder.add(
      whereKey,
      {
        [dateKey]: {
          GTE: (
            filter.defaultDateFrom
              ? moment(filter.defaultDateFrom).toJSON()
              : startOf2020.clone().startOf('month').toJSON()
          ),
          LTE: (
            filter.defaultDateTo
              ? moment(filter.defaultDateTo).toJSON()
              : now.endOf('day').toJSON()
          ),
        },
      },
    );
  },
  getValueForField: (value, props) => {
    const now = moment();
    const startOf2020 = moment('2020-01-01T00:00:00');
    if (value && value.length) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
              .hour(now.hour())
              .minute(now.minute())
              .second(now.second())
              .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        return values;
      }
    }
    // return [
    //   (
    //     props.defaultDateFrom
    //       ? moment(props.defaultDateFrom)
    //       : now.clone().startOf('year')
    //   ),
    //   (
    //     props.defaultDateTo
    //       ? moment(props.defaultDateTo)
    //       : now.startOf('day')
    //   ),
    // ];
    return [
      props.defaultDateFrom
        ? moment(props.defaultDateFrom)
        : startOf2020.clone(),
      props.defaultDateTo
        ? moment(props.defaultDateTo)
        : now.clone().endOf('day'),
    ];
  },
  getValueForQuery: (value) => {
    if (
      Array.isArray(value)
      && value.length === 2
      && value[0] && value[0].isValid()
      && value[1] && value[1].isValid()
    ) {
      // const now = moment();
      return `${value[0].format('YYYY-MM-DD')
        },${value[1].format('YYYY-MM-DD')
        }`;
    }
    return undefined;
  },
  // skip: [
  //   props => props.searchParams['period-span'] !== 'custom',
  // ],
  field: ['FieldDateRangePicker', {
    id: 'periodRange',
    name: 'periodRage',
    format: 'll',
    showToday: false,
    separator: '-',
    // skip: [
    //   props => props.searchParams?.['period-span'] !== 'custom',
    // ],
  }],
}];

export const filterShipping = ['FilterField', {
  id: 'shipping',
  name: 'shipping',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    ...Types.SHIPPING_PROVIDER.reduce(
      (agr, id) => {
        agr[id.toLowerCase()] = { [`shipping.${id}.supported`]: { EQ: true } };
        Types.SHIPPING_STORAGE.forEach(storage => {
          agr[`${id.toLowerCase()}-${storage.toLowerCase()}`] = {
            AND: [
              { [`shipping.${id}.storage`]: { EQ: storage } },
              { [`shipping.${id}.supported`]: { EQ: true } },
            ],
          }
        })
        return agr;
      },
      {},
    ),
  },
  buildQuery: (value, builder, filter) => {
    console.log(filter.VALUES_MAP[value])
    return filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : null
},
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldSelect', {
    name: 'shipping',
    placeholder: 'Shipping',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [
      { label: 'Any Shipping Provider', value: 'any' },
      ...Types.SHIPPING_PROVIDER_LIST
      .filter(({ id }) => (
        [
          'STORE',
          'PACKMAN_SHOP',
          'PACKMAN_RUSH',
          'SELF_PICKUP',
        ].includes(id)
      ))
      .reduce(
        (agr, { id, label }) => {
          agr.push({
            label,
            value: id.toLowerCase(),
          });
          Types.SHIPPING_STORAGE_LIST
          .filter(({ id: storageId }) => (
            [
              'LOCAL',
              'WAREHOUSE',
            ].includes(storageId)
          ))
          .forEach(storage => {
            agr.push({
              label: `${label} (${storage.label})`,
              value: `${id.toLowerCase()}-${storage.id.toLowerCase()}`,
            });
          })
          return agr;
        },
        [],
      ),
    ],
  }],
}];

export const FILTERS = [
  ...[

    [filterSearch, 8],
    [filterAccountManager, 8],
    [filterKeyAccountService, 8],
    [filterSort, 8],
    [filterType, 12],
    [filterShipping, 12],
    [filterAcountManagementService, 12],
    [filterWarehouseServiceService, 12],
    [filterPeriodRange, 24],
    [filterActive, 24],
    [filterGenerateReportSubscriptions, 24],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
];

export const ADMIN = FILTERS;
